import { useDispatch } from 'react-redux';
import { updateFormData } from '../../core/reducers/formDetail';

import { RECLIST_ID_SEP } from '../../../utilities/constant';
import { Id, LOCAL_EMEMO_DATA, additional_title } from '../constants'
import { set } from 'lodash';

class Instrument {
    NatureOfInstrument:string
    PRN:string
    Address:string
    Lot:string
}

export default function useImportData() {
    const dispatch = useDispatch();

    const clearLocalStorage = () => {
        localStorage.removeItem(LOCAL_EMEMO_DATA);
    }
    
    const importDataFromLocalStorge = () => {
    
        const ememo_json = localStorage.getItem(LOCAL_EMEMO_DATA);
        const ememo_data = JSON.parse(ememo_json);
        const ememo_instrumentList = new Map();
        const duplicatedRecords: any[][] = [];
    
        if (ememo_data) {
            // Solicitor Code
            if (ememo_data["SolicitorCode"]) {
                dispatch(updateFormData(null, null, { [Id.SolicitorCode] : ememo_data["SolicitorCode"] }));
            }
    
            // Registration Fee
            if (ememo_data["TotalAmount"]) {
                dispatch(updateFormData(null, null, { [Id.TotalAmount] : ememo_data["TotalAmount"]+"" }));
            }
            
            // Instruments
            if (ememo_data["instruments"] && ememo_data["instruments"].length > 0) {
                dispatch(updateFormData(null, null, { [additional_title+"_recCount"] : ememo_data["instruments"].length }));
                
                ememo_data["instruments"].forEach((instrument:Instrument, i:number) => {
                    const idx = i+1;
                    let desc = "";
                    // Nature of Instrument
                    if (instrument["NatureOfInstrument"]) {
                        let ememo_nature = instrument["NatureOfInstrument"];
                        desc += ememo_nature;
                        dispatch(updateFormData(null, null, { [Id.NatureOfInstrument + RECLIST_ID_SEP + idx] : ememo_nature }));
                    }
    
                    // PRN No. / Address / Lot No.
                    let ememo_desc = "";
                    if (instrument["PRN"]) {
                        ememo_desc = instrument["PRN"];
                    }
                    if (instrument["Address"]) {
                        let ememo_address = instrument["Address"];
                        ememo_desc += ememo_desc?"; ":"";
                        ememo_desc += ememo_address;
                    }
                    if (instrument["Lot"]) {
                        ememo_desc += ememo_desc?"; ":"";
                        ememo_desc += instrument["Lot"];
                    }
                    if (ememo_desc) {
                        dispatch(updateFormData(null, null, { [Id.PRN + RECLIST_ID_SEP + idx] : ememo_desc }));
                    }
                    desc += ememo_desc;
                    
                    // To validate whether there is any other identical description in the list
                    if (ememo_instrumentList.has(desc)) {
                        duplicatedRecords.push([ememo_instrumentList.get(desc), idx]);
                    }
                    else {
                        ememo_instrumentList.set(desc, idx);
                    }
                });
            }
            dispatch(updateFormData(null, null, {
                [Id.importedData] : true,
                [Id.presetSolicitorCode] : ememo_data["SolicitorCode"]?ememo_data["SolicitorCode"]:null
            }));
        }
        return duplicatedRecords;
    }

    return {
        importDataFromLocalStorge:importDataFromLocalStorge,
        clearLocalStorage:clearLocalStorage
    }
}